import { CurrentUser } from './Common/common.interface'

export interface IJson {
  comment_to_ringle: string
  count_result: ICountResult
  current_speaking_evaluation: ICurrentSpeakingEvaluation
  evaluation_training: IEvaluationTraining
  evaluation_training_command: IEvaluationTrainingCommand
  feedanswers: IFeedanswers[]
  feedback: IFeedback
  feedquestions: IFeedquestions[]
  is_feedback_needed: boolean
  is_first_time: boolean
  is_new_version: boolean
  lesson_info: ILessonInfo
  lesson_material: ILessonMaterial
  lesson_study_obj: any[]
  overall_comment: string
  requested_texts: any[]
  revised_texts: any[]
  ringledoc: string
  special: boolean
  special_lesson: boolean
}

export interface ICountResult {
  content_length_of_revised_text: any[]
  count_except_overall_comment: number
  count_overall_comment: number
  indepth_count: number
  indepth_words: number
  minimum_length_of_revised_text: any[]
}

export interface ICurrentSpeakingEvaluation {
  evaluation_categories: IEvaluationCategories[]
  results: number[]
  score_sum: number
}

interface IEvaluationCategories {
  id: number
  title: string
  scores: IScores[]
}

interface IScores {
  score: number
  description: string
  sample_url: any
}

interface IEvaluationTraining {
  evaluation_training_id: number
  evaluation_training_question_response_id: any
  file_url: string
  recommended_avg_score: number
}

interface IEvaluationTrainingCommand {
  condition_satisfied: boolean
  will_create_record: boolean
}

interface IFeedanswers {
  bullet_type: string
  content: string
  feedback_id: number
  feedquestion_id: number
  id: number
  label: string
  picked: any
  reference: any
  right_content: string
  score: any
  student_id: any
  viewable: boolean
  word_content: any
  wrong_content: string
}

interface IFeedback {
  admin_confirmed: boolean
  created_at: string
  deleted_at: any
  has_imported: boolean
  id: number
  is_junior: boolean
  lesson_id: number
  lesson_snapshot_id: any
  status: number
  student_id: number
  tutor_id: number
  updated_at: string
  waiver_comment: any
}

interface IFeedquestions {
  addable: boolean
  answer_type: number
  created_at: string
  description: string
  for_ringle: boolean
  gen: number
  id: number
  minimum_words: number
  ringle_area_id: number
  title: string
  updated_at: string
}

interface ILessonInfo {
  is_junior: boolean
  course_title: string
  document_url: string
  duration: number
  id: number
  interview_lesson: boolean
  new_interview: boolean
  ringledoc: string
  ringledoc_url: string
  special_lesson: boolean
  start_time: string
  student_name: string
}

interface ILessonMaterial {
  class_note_html: string
  class_note_html_url: string
  class_note_text: any
  class_note_url: any
  document_url_for_classroom: string
  ringledoc_url: string
}

export interface PlusTutorFeedbackReportPropsType {
  json: IJson
  currentUser: CurrentUser
}

export interface lessonStyleType {
  data: any
  isError: boolean
  isLoading: boolean
}
export interface BodyType {
  answers: IAnswers[]
}
export interface IAnswers {
  answer_data: IAnswerDataType
  answer_id: number
  bullet_type: string
  feedquestion_id: number
}
export interface IAnswerDataType {
  content: string
  label: string
  right_content: string
  wrong_content: string
}

export enum IKeyword {
  'Used Various Expressions',
  'Precise Language Use',
  'Fluent Delivery',
  'Logical & Comprehensive Answer',
  'Depth of Understanding',
  'Proactive Attitude',
  'Quick Acquisition',
  'Engaging Conversation',
  'Thorough Preparation',
}
export enum IKeyExpressionCategory {
  'Words and Expressions',
  'Grammatical Accuracy',
  'Sentence Variation',
  'Tone and Context',
  'Pronunciation',
}

export enum FEEDBACK_STATUS {
  NOSHOW = 'no_show',
  WRITING_MATERIAL = 'no_record',
  WAIVER = 'waiver',
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
}
